<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1500px">
      <v-card>
        <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
        <v-card-text>
          <v-form ref="EnergyInputDialogForm" v-model="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="2"> 物件名 </v-col>
                <v-col v-if="selectFlg" cols="3">
                  <ryou-select
                    v-model="selectBuild"
                    :value="selectBuild"
                    :label="'物件名'"
                    :items="buildItems"
                    :itemText="'building_name'"
                    :itemValue="'building_id'"
                    :rules="requiredRules"
                  >
                  </ryou-select>
                </v-col>
                <v-col v-else cols="3">
                  <!--{{this.buildItems[this.selectedBuild-1].building_name}}-->
                  {{ this.buildingName }}
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="2"> エネルギー選択 </v-col>
                <v-col v-if="selectFlg" cols="3">
                  <ryou-select
                    v-model="selectEnergy"
                    :value="selectEnergy"
                    :label="'エネルギー選択'"
                    :items="energyItems"
                    :itemText="'code_text'"
                    :itemValue="'code_value'"
                    :rules="requiredRules"
                  >
                  </ryou-select>
                </v-col>
                <v-col v-else cols="3">
                  <!-- {{this.energyItems[this.selectedEnergy].code_text}} -->
                  <!-- // ガス排除-NSTEC START -->
                  {{ this.energyItems[selectEnergyCodeIndex].code_text }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2"> 対象年月日 </v-col>
                <v-col v-if="selectFlg" cols="3">
                  <ryou-date-format
                    v-model="selectMonth"
                    :value="selectMonth"
                    :rules="requiredRules"
                    :label="'対象年月日'"
                    :format="'$1/$2/$3'"
                    :type="'date'"
                  >
                  </ryou-date-format>
                </v-col>
                <v-col v-else cols="3">
                  {{ this.model.input_date }}
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="2"> 部屋番号 </v-col>
                <v-col v-if="selectFlg" cols="3">
                  <ryou-input
                    v-model="room_id"
                    :value="room_id"
                    :rules="roomIdRules"
                    :maxlength="10"
                  ></ryou-input>
                </v-col>
                <v-col v-else cols="3">
                  {{ model.room_id }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2"> 今回メータ値 </v-col>
                <v-col cols="3">
                  <ryou-input
                    v-model="now_meter_val"
                    :value="model.now_meter_val"
                    :rules="meterRules"
                    :maxlength="12"
                  ></ryou-input>
                </v-col>
                <v-col cols="1"></v-col>
                <v-col cols="2"> 前回メータ値 </v-col>
                <v-col cols="3">
                  {{ model.befor_meter_val }}
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="2"> 今回使用量 </v-col>
                <v-col cols="3">
                  {{ model.now_use_amount }}
                </v-col>
                <!-- <v-col cols="3">
                  <ryou-input
                    v-model="now_use_amount"
                    :value="now_use_amount"
                    v-bind:readonly="true"
                    :maxlength="13"
                  ></ryou-input>
                </v-col> -->
                <!-- <v-col cols="3">
                  <v-text-field
                    v-model="now_use_amount"
                    :rules="amountRules"
                    :maxlength="13"
                  ></v-text-field> -->
                <!-- </v-col> -->
                <v-col cols="1"></v-col>
                <v-col cols="2"> 前回使用量 </v-col>
                <v-col cols="3">
                  {{ model.befor_use_amount }}
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'登録'"
            :handlerClick="handleOk"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
export default {
  components: {
    RyouInput,
    RyouSelect,
    RyouBlackBtn,
    RyouDateFormat,
  },
  mounted() {
    this.lowerLimitRule = value => value >= this.model.befor_meter_val || "前回メータ値より大きい値を入力してください" ;
    this.requiredRules.push(this.GlobalRules.required);
    this.roomIdRules.push(
      this.GlobalRules.required,
      this.GlobalRules.counter_10,
      this.GlobalRules.hanAlphahyphen
    );
    this.meterRules.push(
      this.GlobalRules.required,
      this.GlobalRules.number,
      this.GlobalRules.numberMax10000000_point_999,
      this.GlobalRules.number_point_3,
      // this.GlobalRules.integer,
      // this.GlobalRules.numberMin99,
      this.lowerLimitRule
    );
    this.amountRules.push(
      this.GlobalRules.required,
      this.GlobalRules.number,
      this.GlobalRules.numberMax100000000_point_999,
      this.GlobalRules.number_point_3,
      // this.GlobalRules.numberMin99
    );
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {},
    },
    selectedBuild: {
      type: String,
      required: true,
      deault: () => {},
    },
    selectedEnergy: {
      type: String,
      required: true,
      deault: () => {},
    },
    buildItems: {
      type: Array,
      required: true,
      deault: () => {},
    },
    energyItems: {
      type: Array,
      required: true,
      deault: () => {},
    },
    roomItems: {
      type: Array,
      required: true,
      deault: () => {},
    },
  },
  data: () => ({
    selectFlg: true,
    dialog: false,
    title: "",
    valid: true,
    buildingName: "",
    selectBuild: "",
    selectEnergy: "",
    selectMonth: "",
    selectEnergyCodeIndex: "0",
    room_id: "",
    now_meter_val: "",
    now_use_amount: "",
    requiredRules: [],
    roomIdRules: [],
    meterRules: [],
    amountRules: [],  
    model: {
      befor_meter_val: "0",
      befor_use_amount: "0",
    },
    lowerLimitRule: null,
  }),
  watch: {
    selectBuild(value) {
      if (value != null) {
        this.getAmountRecord();
      }
    },
    selectEnergy(value) {
      if (value != null) {
        this.getAmountRecord();
      }
    },
    selectMonth(value) {
      if (value != null) {
        this.getAmountRecord();
      }
    },
    room_id(value) {
      if (value != null) {
        this.getAmountRecord();
      }
    },
    // 使用量自動計算用
    now_meter_val(value) {
      if (value != null) {
        this.calAmount(value);
      }
    },
  },
  methods: {
    add() {
      this.selectFlg = true;
      this.open();
      this.title = "新規";
      this.now_meter_val = "";
      this.model.befor_meter_val = 0;
      this.model.now_use_amount = 0;
      
    },
    edit(record) {
      this.selectFlg = false;
      this.buildItems.forEach((x) => {
        if (x.building_id == this.selectedBuild) {
          this.buildingName = x.building_name;
        }
      });
      this.open();
      this.title = "更新";
      setTimeout(() => {
        this.model = Object.assign({}, record);
        this.model.input_date = record.input_date
          .substr(0, 10)
          .replace(/-/g, "/");
        // ガス排除 enelgyItemsインデックスが[電気:0 水道:1]のため-NSTEC START
        if (record.energyClass == 0) {
          this.selectEnergyCodeIndex = "0";
        } else if (record.energyClass == 2) {
          this.selectEnergyCodeIndex = "1";
        }
        // ガス排除-NSTEC END
      }, 10);
    },
    handleOk() {
      var valid = this.$refs.EnergyInputDialogForm.validate();
      if (valid) {
        var that = this;
        if (!this.selectFlg) {
          // 更新
          let params = {
            energyClass: parseInt(this.selectedEnergy),
            building_id: parseInt(this.selectedBuild),
            room_id: this.model.room_id,
            input_date: new Date(this.model.input_date),
            now_meter_val: parseFloat(this.now_meter_val), // 入力値のためthis.model.~から変更
            use_amount: parseFloat(this.model.now_use_amount),
            upd_user_id: this.$store.getters.getUserId,
          };
          params.input_date.setHours(params.input_date.getHours() + 9);
          this.putRequest(
            this.url.update,
            params,
            this.$store.getters.getUserToken
          ).then((resp) => {
            if (resp.success) {
              that.$emit("ok");
            }
            that.close();
          });
        } else if (valid && this.checkRoomId()) {
          //登録
          //console.log(this.selectMonth)
          let params = {
            energyClass: parseInt(this.selectEnergy),
            building_id: parseInt(this.selectBuild),
            room_id: this.room_id,
            input_date: new Date(this.selectMonth),
            now_meter_val: parseFloat(this.now_meter_val), // 入力値のためthis.model.~から変更
            befor_meter_val: parseFloat(this.model.befor_meter_val),
            use_amount: parseFloat(this.model.now_use_amount),
            reg_user_id: this.$store.getters.getUserId,
            upd_user_id: this.$store.getters.getUserId,
          };
          //console.log(params)
          this.postRequest(
            this.url.add,
            params,
            this.$store.getters.getUserToken
          ).then((resp) => {
            if (resp.success) {
              that.$emit("ok");
            }
            that.close();
          });
        }
      }
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      this.model.befor_meter_val = 0;
      this.model.befor_use_amount = 0;
    },
    open() {
      this.dialog = true;
      if (this.$refs.EnergyInputDialogForm) {
        this.$refs.EnergyInputDialogForm.reset();
        this.$refs.EnergyInputDialogForm.resetValidation();
      }
    },
    checkRoomId() {
      for (let i = 0; i < this.roomItems.length; i++) {
        if (this.selectBuild == this.roomItems[i].building_id) {
          if (this.room_id == this.roomItems[i].room_id) {
            return true;
          }
        }
      }
      this.$toast.open({
        message: "登録できませんでした。使用されていない部屋です。",
        type: "warning",
      });
      return false;
    },
    getAmountRecord() {
      if (
        this.selectEnergy != "" &&
        this.selectBuild != "" &&
        this.model.room_id != "" &&
        this.selectMonth != ""
      ) {
        let params = {
          energy_class: parseInt(this.selectEnergy),
          building_id: parseInt(this.selectBuild),
          room_id: this.room_id,
          input_date: new Date(this.selectMonth),
        };

        this.getRequest(
          "/energyInput/amountRecordGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          //エネルギー区分取得
          if (data.success) {
            this.model.befor_meter_val = data.result[0];
            this.model.befor_use_amount = data.result[1];
          }
        });
      }
    },
    // 今回メータ値変更時　今回使用量計算
    calAmount(nowMeterValStr) {
      const nowMeterVal = Number(nowMeterValStr);
      const decimals = 3;// DBの定義で小数の桁数は3桁のため
      const factor = Math.pow(10, decimals); // 1000
          
      if (nowMeterVal.length == 0) {
        this.model.now_use_amount = 0;
      }
      //前回メータ値と今回メータ値比較
      var beforMeterVal = 0;
      if (this.model.befor_meter_val != null) {
        beforMeterVal = this.model.befor_meter_val;
      }
      if (nowMeterVal >= beforMeterVal) {
        // 前回メータ値と今回メータ値との差を今回使用量とする。
        var diff = Math.round(nowMeterVal* factor - beforMeterVal* factor); 
        var result = Math.floor(diff) / factor; // 浮動小数点の誤差対策(すでに小数で入力しているデータ用)
        this.meterRules= this.meterRules.filter(rule => rule !== this.lowerLimitRule);

        this.model.now_use_amount = result;
      } else {
        // 前回メータ値より小さい場合、今回使用量がマイナス
        var diff = Math.round(nowMeterVal* factor - beforMeterVal* factor); 
        var result = Math.floor(diff) / factor; // 浮動小数点の誤差対策
        if(!this.meterRules.includes(this.lowerLimitRule)){
          this.meterRules.push(this.lowerLimitRule);
        }

        this.model.now_use_amount = result;
      }
    },
  },
};
</script>

<style></style>
